module.exports = __webpack_public_path__ + "d94e20c1/img/document.e2130c6b.svg";